import React, { useEffect, useState } from 'react';
import API from '../api';
import Navbar from '../components/Navbar';
import toast from 'react-hot-toast';

const categories = [
  { value: 'electricity', label: '⚡ Electricity Bill' },
  { value: 'water', label: '💧 Water Bill' },
  { value: 'rent', label: '🏠 Rent' },
  { value: 'salary', label: '👤 Salary' },
  { value: 'transport', label: '🚗 Transport' },
  { value: 'maintenance', label: '🔧 Maintenance' },
  { value: 'other', label: '📦 Other' },
];

const Expenses = () => {
  const [expenses, setExpenses] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState('');
  const [amount, setAmount] = useState('');
  const [category, setCategory] = useState('other');
  const [note, setNote] = useState('');
  const [search, setSearch] = useState('');
  const [filterCategory, setFilterCategory] = useState('all');

  const fetchExpenses = async () => {
    setLoading(true);
    try {
      const [expensesRes, summaryRes] = await Promise.all([
        API.get('/expenses'),
        API.get('/expenses/summary'),
      ]);
      setExpenses(expensesRes.data);
      setSummary(summaryRes.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  const [addingExpense, setAddingExpense] = useState(false);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (addingExpense) return;
    setAddingExpense(true);
    try {
      await API.post('/expenses', {
        title,
        amount: parseFloat(amount),
        category,
        note,
      });
      toast.success('Expense added!');
      setTitle('');
      setAmount('');
      setCategory('other');
      setNote('');
      fetchExpenses();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to add expense');
    }
    setAddingExpense(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this expense?')) return;
    try {
      await API.delete(`/expenses/${id}`);
      toast.success('Expense deleted!');
      fetchExpenses();
    } catch (err) {
      toast.error('Failed to delete expense');
    }
  };

  const getCategoryLabel = (value) => {
    const cat = categories.find((c) => c.value === value);
    return cat ? cat.label : value;
  };

  const filteredExpenses = expenses.filter((e) => {
    const matchSearch = e.title.toLowerCase().includes(search.toLowerCase());
    const matchCategory = filterCategory === 'all' || e.category === filterCategory;
    return matchSearch && matchCategory;
  });

  return (
    <div>
      <Navbar />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div style={styles.container} className="container">
        <h2 style={styles.title}>Expenses</h2>

        {summary && (
          <div style={styles.summaryCards}>
            <div style={styles.summaryCard}>
              <p style={styles.summaryLabel}>Total Expenses</p>
              <p style={{ ...styles.summaryValue, color: '#ef4444' }}>
                LKR {parseFloat(summary.total).toFixed(2)}
              </p>
            </div>
            {summary.summary?.map((s, i) => (
              <div key={i} style={styles.summaryCard}>
                <p style={styles.summaryLabel}>{getCategoryLabel(s.category)}</p>
                <p style={styles.summaryValue}>LKR {parseFloat(s.total_amount).toFixed(2)}</p>
              </div>
            ))}
          </div>
        )}

        <div style={styles.card}>
          <h3 style={styles.subtitle}>Add New Expense</h3>
          <form onSubmit={handleAdd}>
            <div style={styles.formRow}>
              <input
                style={styles.input}
                type="text"
                placeholder="Expense Title (e.g. January Electricity)"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
              <input
                style={styles.input}
                type="number"
                placeholder="Amount (LKR)"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                min="0"
                required
              />
              <select
                style={styles.input}
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                {categories.map((c) => (
                  <option key={c.value} value={c.value}>{c.label}</option>
                ))}
              </select>
            </div>
            <input
              style={{ ...styles.input, width: '100%', marginBottom: '1rem' }}
              type="text"
              placeholder="Note (optional)"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
<button style={{ ...styles.button, opacity: addingExpense ? 0.6 : 1 }} type="submit" disabled={addingExpense}>
              {addingExpense ? 'Adding...' : 'Add Expense'}
            </button>          </form>
        </div>

        <div style={styles.filterRow}>
          <input
            style={styles.search}
            type="text"
            placeholder="Search expenses..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <select
            style={styles.filterSelect}
            value={filterCategory}
            onChange={(e) => setFilterCategory(e.target.value)}
          >
            <option value="all">All Categories</option>
            {categories.map((c) => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </select>
        </div>

        {loading ? (
          <div style={styles.loaderWrapper}>
            <div style={styles.spinner}></div>
            <p style={styles.loaderText}>Loading expenses...</p>
          </div>
        ) : (
          <div className="mobile-scroll-wrapper"><p className="mobile-scroll-hint">← Swipe to see more →</p><table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Title</th>
                <th style={styles.th}>Category</th>
                <th style={styles.th}>Amount (LKR)</th>
                <th style={styles.th}>Note</th>
                <th style={styles.th}>Date</th>
                <th style={styles.th}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredExpenses.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ ...styles.td, textAlign: 'center', color: '#888' }}>
                    No expenses found
                  </td>
                </tr>
              ) : (
                filteredExpenses.map((e) => (
                  <tr key={e.id}>
                    <td style={styles.td}>{e.title}</td>
                    <td style={styles.td}>{getCategoryLabel(e.category)}</td>
                    <td style={{ ...styles.td, color: '#ef4444', fontWeight: 'bold' }}>
                      {parseFloat(e.amount).toFixed(2)}
                    </td>
                    <td style={styles.td}>{e.note || '-'}</td>
                    <td style={styles.td}>{new Date(e.created_at).toLocaleDateString()}</td>
                    <td style={styles.td}>
                      <button onClick={() => handleDelete(e.id)} style={styles.deleteBtn}>Delete</button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table></div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: { padding: '2rem' },
  title: { fontSize: '24px', marginBottom: '1.5rem' },
  subtitle: { fontSize: '16px', marginBottom: '1rem' },
  summaryCards: { display: 'flex', gap: '1rem', flexWrap: 'wrap', marginBottom: '1.5rem' },
  summaryCard: { background: '#fff', padding: '1rem 1.5rem', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', flex: 1, minWidth: '150px' },
  summaryLabel: { color: '#888', fontSize: '13px', margin: '0 0 4px' },
  summaryValue: { fontSize: '20px', fontWeight: 'bold', margin: 0, color: '#4f46e5' },
  card: { background: '#fff', padding: '1.5rem', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', marginBottom: '1.5rem' },
  formRow: { display: 'flex', gap: '1rem', flexWrap: 'wrap', marginBottom: '0.5rem' },
  input: { padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', flex: 1, minWidth: '150px' },
  button: { padding: '10px 24px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' },
  filterRow: { display: 'flex', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' },
  search: { flex: 2, padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', minWidth: '150px' },
  filterSelect: { flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', minWidth: '150px' },
  loaderWrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '4rem' },
  spinner: { width: '40px', height: '40px', border: '4px solid #e0e7ff', borderTop: '4px solid #4f46e5', borderRadius: '50%', animation: 'spin 0.8s linear infinite' },
  loaderText: { marginTop: '1rem', color: '#888', fontSize: '14px' },
  table: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  th: { padding: '12px 16px', background: '#4f46e5', color: '#fff', textAlign: 'left', fontSize: '14px' },
  td: { padding: '12px 16px', borderBottom: '1px solid #f0f0f0', fontSize: '14px' },
  deleteBtn: { padding: '6px 12px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
};

export default Expenses;